import { defineReactComponent } from "@omnia/shared/react/angular"
import { MigrateDialog } from "./Dialog"

export function defineMigrateDialog() {
    return defineReactComponent({
        inject: {
            shell: "OmniaShell",
            version: "OmniaNutritionVersion",
            "$window": "$window"
        },

        start(context) {
            const { rootElement } = context

            const element = React.createElement(MigrateDialog, {
                ...context,
            })

            ReactDOM.render(element, rootElement)
        },
    })
}
